import { useState, useEffect } from "react";
import CrossIcon from "../assets/crossIcon.svg";
import { ReportServices } from "../services/ReportServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";
const EditTimeColorInfo = ({
  selectedStage,
  stageIdPairData,
  stageColorData,
  setOpen,
  getStageTimeColor,
}) => {
  const [colorTimeData, setColorTimeData] = useState(selectedStage?.records);
  const [saving, setSaving] = useState(false);
  const [isChanged, setIsChanged] = useState(false);

  const handleTimeLimitChange = (e, index) => {
    {
      const updated = [...colorTimeData];
      updated[index].minTimeLimit = Number(e.target.value);
      if (index > 0) {
        updated[index].startTime = updated[index - 1].endTime;
        if (index < colorTimeData?.length - 1) {
          updated[index].endTime =
            Number(updated[index - 1].endTime) + Number(e.target.value);
        } else {
          updated[index].endTime = "";
        }
      } else {
        updated[index].startTime = 0;
        updated[index].endTime = Number(e.target.value);
      }
      for (let idx = index + 1; idx < colorTimeData?.length; idx++) {
        updated[idx].startTime = updated[idx - 1].endTime;
        if (idx < colorTimeData?.length - 1) {
          updated[idx].endTime =
            Number(updated[idx - 1].endTime) +
            Number(updated[idx].minTimeLimit);
        } else {
          updated[idx].endTime = "";
        }
      }
      setColorTimeData(updated);
      setIsChanged(true);
    }
  };
  const updateData = async () => {
    setSaving(true);
    try {
      if (isChanged) {
        const response = await ReportServices.updateStatusTimeColor(
          colorTimeData
        );
        window.alert(response.data.message);
        await getStageTimeColor();
        setOpen(null);
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setSaving(false);
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      return (document.body.style.overflow = "auto");
    };
  }, []);

  return (
    <div className="fixed h-screen w-screen top-0 left-0 flex justify-center items-center bg-[#017C5780] z-[1201]">
      <div className="relative h-[75%] 2xl:h-[60%] w-[90%] 2xl:w-[80%] flex items-center justify-center bg-white px-10 py-5 rounded-[20px]">
        <div className="absolute right-8 top-5 cursor-pointer ">
          <img
            src={CrossIcon}
            alt="close-popup-icon"
            onClick={() => setOpen(null)}
          />
        </div>

        <div className="w-full h-[85%]">
          <div className="w-full mt-5 h-[85%] overflow-y-auto pr-2">
            {colorTimeData?.map((color, index) => (
              <div
                key={index}
                className="flex justify-between items-end mb-4 gap-4"
              >
                {" "}
                <div>
                  Time Limit:{" "}
                  <input
                    type="text"
                    value={color.minTimeLimit}
                    onChange={(e) => handleTimeLimitChange(e, index)}
                    style={{ border: "1px solid #E4E4E4" }}
                    className="w-full outline-none p-2 rounded-[8px] mt-2"
                  />
                </div>
                <div>
                  Start Time:{" "}
                  <input
                    type="text"
                    disabled
                    value={color.startTime}
                    onChange={(e) => {
                      const updated = [...colorTimeData];
                      updated[index].startTime = e.target.value;
                      setColorTimeData(updated);
                      setIsChanged(true);
                    }}
                    style={{ border: "1px solid #E4E4E4" }}
                    className="w-[50px] outline-none p-2 rounded-[8px] mt-2"
                  />
                </div>
                <div>
                  End Time:{" "}
                  <input
                    type="text"
                    disabled
                    value={color.endTime}
                    onChange={(e) => {
                      const updated = [...colorTimeData];
                      updated[index].endTime = e.target.value;
                      setColorTimeData(updated);
                      setIsChanged(true);
                    }}
                    style={{ border: "1px solid #E4E4E4" }}
                    className="w-[50px] outline-none p-2 rounded-[8px] mt-2"
                  />
                </div>
                <div>
                  Points:{" "}
                  <input
                    type="text"
                    value={color.points}
                    onChange={(e) => {
                      const updated = [...colorTimeData];
                      updated[index].points = e.target.value;
                      setColorTimeData(updated);
                      setIsChanged(true);
                    }}
                    style={{ border: "1px solid #E4E4E4" }}
                    className="w-[50px] outline-none p-2 rounded-[8px] mt-2"
                  />
                </div>
                <div
                  style={{
                    color: color?.textColor,
                    backgroundColor: color?.bgColor,
                    padding: "4px",
                    borderRadius: "4px",
                    width: "10%",
                    textAlign: "center",
                  }}
                >
                  {color?.type}
                </div>
                <div>
                  <div className="text-nowrap">Text Color:</div>
                  <input
                    type="color"
                    value={color.textColor?.slice(0, 7)}
                    onChange={(e) => {
                      const updated = [...colorTimeData];
                      updated[index].textColor = e.target.value;
                      setColorTimeData(updated);
                      setIsChanged(true);
                    }}
                    className="w-full h-[40px] outline-none border-none  mt-2"
                  />
                </div>
                <div>
                  <div className="text-nowrap">Background Color:</div>{" "}
                  <input
                    type="color"
                    value={color.bgColor?.slice(0, 7)}
                    onChange={(e) => {
                      const updated = [...colorTimeData];
                      updated[index].bgColor = e.target.value;
                      setColorTimeData(updated);
                      setIsChanged(true);
                    }}
                    className="w-full h-[40px] outline-none border-none  mt-2"
                  />
                </div>
              </div>
            ))}
          </div>
          <div className="flex justify-center mt-2">
            {saving ? (
              <CircularProgress />
            ) : (
              <div
                className="w-fit text-sm font-semibold text-white bg-[#017C57] px-10 py-3 rounded-full cursor-pointer"
                onClick={() => isChanged && updateData()}
              >
                SUBMIT
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTimeColorInfo;
